<template>
  <v-data-table :headers="headers"
                :items="items"
                :loading="filters.filter_by_user_loading_status">
    <template v-slot:item.actions="{ item }">
      <gg-btn
             color="primary"
             :to="manageLink(item)">
        Manage
      </gg-btn>
    </template>
  </v-data-table>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'

export default {
  name: 'Table',
  props: {
    // Where Manage leads, as `(email) => location`. The hosting section's
    // route is the default; the Email section passes its own.
    manageTo: {
      type: Function,
      default: null,
    },
  },
  data: () => ({
    headers: [
      {
        text: 'Account',
        value: 'email',
        sortable: false,
      },
      {
        text: 'Actions',
        value: 'actions',
        sortable: false,
        align: 'center'
      }
    ],
    items: []
  }),
  computed: {
    ...mapGetters({
      filters: 'email/filters',
    }),
  },
  methods: {
    ...mapActions({
      composeEmails: 'email/composeEmails',
      reportError: 'reportError',
    }),
    manageLink (item) {
      if (this.manageTo) return this.manageTo(item.email)
      return { name: 'hosting_email_filters_manage', query: { account: item.email, user: this.$route.query.user } }
    },
    async getUsers () {
      try {
        await this.composeEmails(this.$route.query.user)
        this.items = this.filters.list_by_user
      } catch (e) {
        this.reportError(e)
      }
    },
  },
  async mounted () {
    await this.getUsers()
  }
}
</script>
